import { Link } from 'react-router-dom';

import { useAuth } from '@/auth';
import { Button } from '@/components/ui/button';

export function UnauthorizedPage() {
  const { logout } = useAuth();

  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <div className="max-w-md text-center">
        <h1 className="text-lg font-semibold">Unauthorized</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          You do not have access to this page. Contact an administrator if you think this is a
          mistake.
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-2">
          <Button asChild variant="outline">
            <Link to="/">Go to Dashboard</Link>
          </Button>
          <Button onClick={logout}>Log Out</Button>
        </div>
      </div>
    </div>
  );
}
